import {
  ChangeDetectionStrategy,
  Component,
  inject,
  signal
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { SvgIconComponent } from '@ngneat/svg-icon';
import { TranslateModule } from '@ngx-translate/core';

import { MarkdownHintVisibilityService } from '../../services/markdown-hint-visibility.service';

@Component({
  selector: 'bl-markdown-formatting-hint',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, IonicModule, SvgIconComponent, TranslateModule],
  templateUrl: './ui-markdown-formatting-hint.component.html',
  styleUrls: ['./ui-markdown-formatting-hint.component.scss']
})
export class MarkdownFormattingHintComponent {
  private readonly visibility = inject(MarkdownHintVisibilityService);

  readonly expanded = signal(false);
  readonly hidden = signal(this.visibility.isHidden());

  toggleDetails(): void {
    this.expanded.update(v => !v);
  }

  hide(): void {
    this.visibility.setHidden(true);
    this.hidden.set(true);
  }

  show(): void {
    this.visibility.setHidden(false);
    this.hidden.set(false);
  }
}
